<script setup lang="ts">
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { getMySettings } from '@/api'
import { useToast } from '@/composables/useToast'
import { reportError } from '@/errorReport'
import { resolveOpenLink } from '@/protocols/openLink'
import { useTodosStore } from '@/stores/todos'

// The page the browser opens for a `web+todo:` or `geo:` link (`protocols/register.ts`): `?uri=` is the whole link.
// It is behind the sign-in like every page, which brings the visitor back here afterwards.
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const store = useTodosStore()
const toast = useToast()

onMounted(async () => {
  const uri = typeof route.query.uri === 'string' ? route.query.uri : ''
  try {
    const result = await resolveOpenLink(uri, {
      calendars: async () => {
        await store.loadCalendars()
        return store.calendars
      },
      mapProvider: async () => (await getMySettings()).map_provider,
    })
    if (result.notice) toast.info(t(`openLink.${result.notice}`))
    if (result.kind === 'external') {
      window.location.replace(result.url)
    } else if (result.kind === 'route') {
      await router.replace(result.location)
    } else {
      await router.replace({ name: 'todos' })
    }
  } catch (e) {
    reportError(e, 'openLink.failed')
    toast.error(e, t('openLink.failed'))
    await router.replace({ name: 'todos' })
  }
})
</script>

<template>
  <p class="opening">{{ t('openLink.opening') }}</p>
</template>

<style scoped>
.opening {
  padding: 24px 16px;
  text-align: center;
  color: var(--tg-hint-color);
}
</style>
